import { render, staticRenderFns } from "./TemplateTable.vue?vue&type=template&id=70e238c9&scoped=true"
import script from "./TemplateTable.vue?vue&type=script&lang=js"
export * from "./TemplateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e238c9",
  null
  
)

export default component.exports